import {
  getSignatureStatus,
  getSigningUrl,
  hasSignedEnrollmentAgreement
} from '../../utils/utils'
import type { HydrateEnrollmentSessionFn, SigningUrlResult } from '../../types'

type RecoverSigningSessionArgs = {
  hydrateEnrollmentSession: HydrateEnrollmentSessionFn
  setSignatureStatus: (value: string | null) => void
  completeSigningFlow: () => Promise<void>
  openDocusignModalWithUrl: (signingUrl: string) => void
}

export async function recoverExistingSigningSession({
  hydrateEnrollmentSession,
  setSignatureStatus,
  completeSigningFlow,
  openDocusignModalWithUrl
}: RecoverSigningSessionArgs) {
  const state = await hydrateEnrollmentSession(true)
  if (!state) {
    return false
  }

  const status = getSignatureStatus(state)
  const signed = hasSignedEnrollmentAgreement(state)
  const signingUrl = getSigningUrl(state as SigningUrlResult)

  setSignatureStatus(status)

  if (signed) {
    await completeSigningFlow()
    return true
  }

  if (signingUrl) {
    openDocusignModalWithUrl(signingUrl)
    return true
  }

  return false
}
